import { ActionTypes } from '../constants/actionTypes.js';

export const setAuditLogtype = (auditType) => ({
    type: ActionTypes.SET_AUDIT_TYPE_SELECTION,
    payload: auditType
});

export const resetAuditGridData = () => ({
    type: ActionTypes.RESET_AUDIT_GRID_DATE
})